/**
 * Build query string for GET /v1/admin/tasks from URLSearchParams.
 * Defaults match the original tasks list: open + maintenance-only (omit kind).
 */
export default function buildAdminTasksQuery(searchParams) {
  const params = new URLSearchParams(
    typeof searchParams === 'string' ? searchParams : searchParams?.toString?.() || ''
  );
  const q = new URLSearchParams();

  const status = params.get('status');
  if (status && ['open', 'closed', 'all'].includes(status)) {
    q.set('status', status);
  } else {
    q.set('status', 'open');
  }

  const kind = params.get('kind');
  if (kind === 'feedback' || kind === 'all') {
    q.set('kind', kind);
  }

  if (params.get('created_by_me') === '1') {
    q.set('created_by_me', '1');
  }

  const assetId = params.get('asset_id');
  if (assetId && /^\d+$/.test(assetId)) {
    q.set('asset_id', assetId);
  }

  const limit = params.get('limit');
  if (limit && /^\d+$/.test(limit)) {
    q.set('limit', limit);
  }

  return q.toString();
}
